import _ from 'lodash'

function splitEvaluatorFactory(separator) {
	return function splitEvaluator(value) {
		if (_.isEmpty(value)) {
			return null
		}

		return value.split(separator)
	}
}

export default splitEvaluatorFactory

splitEvaluatorFactory.__filename__ = 'components/evaluators/split-evaluator-factory.js'
